export default __webpack_public_path__ + "static/invimatic-iso-more-news-1-54822d63d95d419c62e9cf3e5db9bb99.png";